import CommonError from '../Common/CommonError'

const Error400Container = () => {
  return (
    <CommonError error="400" color="info" src="sad" />
  )
}

export default Error400Container